import React, { useEffect, useState } from 'react'

import PaymentFailedComponent from '../../Components/PaymentFailedComponent/PaymentFailedComponent'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import { GetLocalStorageParsed } from '../utils/page'

const PaymentFailed = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const [loginToken, setLoginToken] = useState(FetchToken || null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
 
  return (
    <>
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>

      <Header setLoginToken={setLoginToken}/>
     <PaymentFailedComponent/>
      <Footer />
      </div>
    </>
  )
}

export default PaymentFailed
